import { render } from "./SaleCpltComp.vue?vue&type=template&id=55b0c694&scoped=true&ts=true"
import script from "./SaleCpltComp.vue?vue&type=script&lang=ts"
export * from "./SaleCpltComp.vue?vue&type=script&lang=ts"

import "./SaleCpltComp.vue?vue&type=style&index=0&id=55b0c694&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b0c694"]])

export default __exports__